import { IsArray, IsBoolean, IsDate, IsDefined, IsString } from "class-validator";

import { GField, GInputType, GObjectType } from "../graphql";

@GObjectType("SimpleBlacklistedDate")
@GInputType("SimpleBlacklistedDateInput")
export class SimpleBlacklistedDate {
    @IsDate()
    @IsDefined()
    @GField()
    public date: Date;

    @IsString()
    @IsDefined()
    @GField()
    public message: string;

    @IsString()
    @IsDefined()
    @GField()
    public description: string;

    @IsBoolean()
    @IsDefined()
    @GField()
    public isBlacklistedDate: boolean;

    @IsArray()
    @IsDefined()
    @GField(() => [String])
    public countryIds: string[] = [];

    @IsArray()
    @IsDefined()
    @GField(() => [String])
    public locationIds: string[] = [];
}
